import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Chevron } from 'src/components/ui/Features/Chevron/Chevron';
import useUser from 'src/hook/data/useUser';
import { ChevronType, LanguageLevel } from 'src/model/enum/enums';
import { ImageLocation } from 'src/utils/URLUtils';
import styles from './ScenarioSection.module.scss';

export const ScenarioSection = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { userInfo } = useUser();
    const isLesson = useMemo(() => {
        return userInfo?.LanguageLevel === LanguageLevel.Beginner ||
            userInfo?.LanguageLevel === LanguageLevel.Basic;
    }, [userInfo?.LanguageLevel]);

    return (
        <section className={styles.scenarioSection}>
            <h2 className='homeTitle'>{!isLesson ? t('Basic Lessons') : t('Scenarios')}</h2>
            <p dir={i18n.dir()} className='homeSubtitle'>{!isLesson ?
                t('Perhaps too easy for you, but in case you need:') :
                t('Practice using words in different real-life situations.')}</p>

            <div className={styles.box} onClick={() => navigate(isLesson ? '/scenario' : '/lessons')}>
                <img className={styles.icon}
                    src={ImageLocation(`Subscribe/${isLesson ? 'books.png' : 'lessons.png'}`)} alt={t('Books')} />
                <p dir={i18n.dir()}>
                    {isLesson ?
                        t('Focus on the vocabulary you need for what is up today.') :
                        t('Beginner-friendly lessons, step by step.')}
                </p>
                <Chevron type={ChevronType.Right} />
            </div>
        </section>
    );
};
